
import { useEffect, useState } from "react";

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from "react-router";

import { RootState } from '../../store';

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Switch, IconButton, TableFooter, TablePagination, Typography, Button, Grid, Dialog, DialogActions, DialogContent, CircularProgress, FormControl, InputLabel, Select, MenuItem, Paper } from "@mui/material"

import EditIcon from "@mui/icons-material/Edit";
import UndoIcon from '@mui/icons-material/Undo';

import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { Layout } from "../../components/Layout"

import { SearchTextField } from "../../components/SearchTextField";

import { TablePaginationActions } from "../../helpers/TablePaginationActions";
import { usePages } from "../../hooks/usePages";
import { useFilter } from "../../hooks/useFilter";

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from "../../styles/DialogStyle";

import { ObtenerTipoJuicio } from "../../connections/catalogos/TipoJuicioConnection";
import { ObtenerTipoConceptos } from "../../connections/catalogos/TipoConceptoConnection";

import { ActualizarTipoConceptoJuicio, AgregarTipoConceptoJuicio, TiposConceptoJuicio } from "../../connections/catalogos/TipoConceptoJuicioConnection";

import { TipoJuicioProps } from "../../interfaces/catalogos/TipoJuicioInterface";
import { TipoConceptoProps } from "../../interfaces/catalogos/TipoConceptoInterface";
import { TipoConceptoJuicioProps } from "../../interfaces/catalogos/TipoConceptoJuicioInterface";

export const TipoConceptoJuicioPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador } = useSelector( ( state: RootState ) => state.auth );

    const [idTipoConceptoJuicio, setIdTipoConceptoJuicio] = useState(0);
    const [tipoConceptoJuicio, setTipoConceptoJuicio] = useState<TipoConceptoJuicioProps[]>([]);

    const [tipoConcepto, setTipoConcepto] = useState(0);
    const [tipoConceptoArray, setTipoConceptoArray] = useState<TipoConceptoProps[]>([]);

    const [tipoJuicio, setTipoJuicio] = useState(0);
    const [tipoJuicioArray, setTipoJuicioArray] = useState<TipoJuicioProps[]>([]);

    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(true);

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages(10);

    const { filtro, setFiltro, dataFiltrada } = useFilter(tipoConceptoJuicio, (item, filtro) => (item.tipoConcepto?.descripcion ?? "").toLowerCase().includes(filtro.toLowerCase()));
    const { filtro: filtro2, setFiltro: setFiltro2, dataFiltrada: dataFiltradaFinal } = useFilter(dataFiltrada, (item, filtro2) => (item.tipoJuicio?.descripcion ?? "").toLowerCase().includes(filtro2.toLowerCase()));

    const handleChangeChecked = async (checked: boolean, id: number) => {

        const tipoConceptoJuicioselected = tipoConceptoJuicio.find((elem) => elem.idTipoConceptoJuicio === id);

        if (tipoConceptoJuicioselected) {

            await ActualizarTipoConceptoJuicio({ ...tipoConceptoJuicioselected, activo: checked }).then(resp => {

                if (resp.idTipoConceptoJuicio) {

                    var newArray = tipoConceptoJuicio.map((elem) => {

                        if (elem.idTipoConceptoJuicio === id) {
                            elem.activo = checked;
                        }

                        return elem;
                    });

                    setTipoConceptoJuicio(newArray);

                    dispatch(openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));
                }

            });
        }

    }

    const handleGuardar = async () => {

        if (idTipoConceptoJuicio !== 0) {

            const tipoConceptoJuicioSelected = tipoConceptoJuicio.find((elem) => elem.idTipoConceptoJuicio === idTipoConceptoJuicio);

            if (tipoConceptoJuicioSelected) {

                setLoading(true);

                await ActualizarTipoConceptoJuicio({ ...tipoConceptoJuicioSelected, idTipoJuicio: tipoJuicio, idTipoConcepto: tipoConcepto }).then(resp => {

                    if (resp.idTipoConceptoJuicio) {

                        setTimeout(() => {

                            var newArray = tipoConceptoJuicio.map((elem) => {

                                if (elem.idTipoConceptoJuicio === idTipoConceptoJuicio) {
                                    elem.idTipoJuicio = tipoJuicio;
                                    elem.tipoJuicio = resp.tipoJuicio
                                    elem.idTipoConcepto = tipoConcepto;
                                    elem.tipoConcepto = resp.tipoConcepto
                                }

                                return elem;
                            });

                            setTipoConceptoJuicio(newArray);
                            setOpenModal(false);
                            setLoading(false);

                            dispatch(openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));

                        }, 700);

                    }

                });
            }

        }
        else {

            const tipoConceptoJucioAdd: TipoConceptoJuicioProps = {
                idTipoConceptoJuicio: 0,
                idTipoConcepto: tipoConcepto,
                idTipoJuicio: tipoJuicio,
                activo: true,
            };

            setLoading(true);

            await AgregarTipoConceptoJuicio(tipoConceptoJucioAdd).then(resp => {

                if (resp.idTipoConceptoJuicio) {

                    setTimeout(() => {

                        setTipoConceptoJuicio([...tipoConceptoJuicio, resp]);
                        setOpenModal(false);
                        setLoading(false);

                        dispatch(openSnackbar({ message: 'Se agregó el tipo de concepto por juicio correctamente', variant: 'success' }));

                    }, 700);

                }

            });

        }

    }

    useEffect(() => {

        async function obtener() {

            setLoadingData(true);
            setTipoConceptoJuicio([]);

            await TiposConceptoJuicio().then(resp => {

                setTimeout(() => {

                    setTipoConceptoJuicio(resp);
                    setLoadingData(false);

                }, 700);

            });

        }

        obtener();

    }, [])

    useEffect(() => {

        async function obtener() {

            setTipoConceptoArray([]);

            await ObtenerTipoConceptos().then(resp => {

                setTimeout(() => {

                    setTipoConceptoArray(resp);

                }, 700);

            });

        }

        obtener();

    }, [])

    useEffect(() => {

        async function obtener() {

            setTipoJuicioArray([]);

            await ObtenerTipoJuicio().then(resp => {

                setTimeout(() => {

                    setTipoJuicioArray(resp);

                }, 700);

            });

        }

        obtener();

    }, [])

    return (

        <Layout breadcrumbs={[{ text: 'Administración' }, { text: 'Catálogos' }, { text: 'Tipo de concepto por juicio' }]} backgroundPaper={false}>

            <Grid container spacing={3} >

                <Grid size={{ xs: 6 }} textAlign={'start'}>

                    {
                        administrador
                        &&
                            <Button startIcon={<UndoIcon />} color="secondary" variant="text" sx={{ mt: 1 }} onClick={() => navigate('/')}>
                                Regresar
                            </Button>
                    }

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={'end'}>

                    <Button
                        variant="contained"
                        sx={{ mt: 1 }}
                        disabled={loadingData}
                        onClick={() => {

                            setIdTipoConceptoJuicio(0);
                            setTipoJuicio(0);
                            setTipoConcepto(0);

                            setOpenModal(true);
                        }}
                    >
                        Agregar
                    </Button>

                </Grid>

            </Grid>

            <Grid container spacing={2} sx={{ mt: 2 }}>

                <Grid size={{ xs: 12, md: 6 }} textAlign={'start'}>

                    <SearchTextField
                        value={filtro}
                        label="Buscar tipo de concepto "
                        onChange={(value) => {
                            setFiltro(value);
                            resetPage();
                        }}
                        onClear={() => resetPage()}
                    />

                </Grid>

                <Grid size={{ xs: 12, md: 6 }} textAlign={'start'}>

                    <SearchTextField
                        value={filtro2}
                        label="Buscar tipo de juicio "
                        onChange={(value) => {
                            setFiltro2(value);
                            resetPage();
                        }}
                        onClear={() => resetPage()}
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={Paper}>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '35%' }}> Tipo de concepto </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '35%' }}> Tipo de juicio </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%' }}>  </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                    ?
                                    dataFiltradaFinal.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    :
                                    dataFiltradaFinal
                            )
                                .map(({ idTipoConceptoJuicio, activo, idTipoJuicio, tipoJuicio, idTipoConcepto, tipoConcepto, }) => (

                                    <TableRow key={idTipoConceptoJuicio} >

                                        <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                                            {idTipoConceptoJuicio}
                                        </TableCell>

                                        <TableCell>
                                            {tipoConcepto?.descripcion}
                                        </TableCell>

                                        <TableCell>
                                            {tipoJuicio?.descripcion}
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'end' }}>

                                            <Switch
                                                checked={activo}
                                                onChange={(e) => handleChangeChecked(e.target.checked, idTipoConceptoJuicio)}
                                            />

                                            <IconButton
                                                color="primary"
                                                aria-label="edit"
                                                component="span"
                                                onClick={() => {

                                                    setIdTipoConceptoJuicio(idTipoConceptoJuicio);
                                                    setTipoJuicio(idTipoJuicio);
                                                    setTipoConcepto(idTipoConcepto);

                                                    setOpenModal(true);
                                                }}
                                            >
                                                <EditIcon />
                                            </IconButton>

                                        </TableCell>

                                    </TableRow>

                                ))
                        }

                        {
                            (dataFiltradaFinal.length === 0 && !loadingData)
                                ?
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={7} align="center">

                                        <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>

                                    </TableCell>

                                </TableRow>
                                :
                                loadingData
                                &&
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={7} align="center">

                                        <CircularProgress size={32} />

                                    </TableCell>

                                </TableRow>
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltradaFinal.length !== 0
                            &&
                            <TableRow>

                                <TableCell colSpan={2} sx={{ border: 'none' }}>
                                    <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                        Total de registros: {dataFiltradaFinal.length}
                                    </Typography>
                                </TableCell>

                                <TablePagination
                                    sx={{ border: 'none' }}
                                    rowsPerPageOptions={[5, 10, 20, 50, 100]}
                                    colSpan={8}
                                    count={dataFiltradaFinal.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}

                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}

                                    ActionsComponent={TablePaginationActions}

                                    labelRowsPerPage="Filas por página"
                                    labelDisplayedRows={
                                        ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                        }
                                    }
                                />

                            </TableRow>
                        }

                    </TableFooter>

                </Table>

            </TableContainer>

            <Dialog open={openModal} maxWidth='sm' fullWidth={true}>

                <DialogContent sx={DialogContentStyle}>

                    <Grid container spacing={3} sx={{ mt: 3 }}>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <FormControl fullWidth>
                                <InputLabel>Tipo concepto</InputLabel>

                                <Select
                                    label='Tipo concepto'
                                    value={tipoConcepto}
                                    onChange={(e) => setTipoConcepto(parseInt(e.target.value.toString() ?? '0'))}
                                >
                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>
                                    {
                                        tipoConceptoArray.map((elem) => (
                                            <MenuItem key={elem.idTipoConcepto} value={elem.idTipoConcepto}> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>


                            </FormControl>

                        </Grid>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <FormControl fullWidth>
                                <InputLabel>Tipo juicio</InputLabel>

                                <Select
                                    label='Tipo juicio'
                                    value={tipoJuicio}
                                    onChange={(e) => setTipoJuicio(parseInt(e.target.value.toString() ?? '0'))}
                                >
                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>
                                    {
                                        tipoJuicioArray.map((elem) => (
                                            <MenuItem key={elem.idTipoJuicio} value={elem.idTipoJuicio}> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>


                            </FormControl>

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions sx={DialogActionsStyle}>
                    <Button color="secondary" disabled={loading} onClick={() => { setOpenModal(false); }}> Cancelar </Button>
                    <Button loading={loading} disabled={tipoJuicio === 0 || tipoConcepto === 0} onClick={handleGuardar} variant='contained'> Guardar </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}